export const TokenExpiredCode = "clerk-session-token-is-expired" as const;
